import React from "react"
import PropTypes from "prop-types"
import "./styles.scss"

const Geoblocking = ({ sharedScreener }) => (
  <div
    className={`icon 
      ${sharedScreener.is_geoblocked ? "isgeoblocked" : "isnotgeoblocked"}
    } 
    relative circle flex items-center justify-center box-shadow`}>
    <span className='material-icons white' style={{ fontSize: "14px" }}>
      vpn_lock
    </span>
  </div>
)

Geoblocking.propTypes = {
  sharedScreener: PropTypes.object.isRequired
}

export default Geoblocking
